import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  orderConfirmation: {
    marginBottom: base(4),
  },
});
